import React, { useState, useEffect } from "react";
import { Button as RaButton } from "react-admin";
import { ListItem, ListItemIcon, Popover, ListItemText, Checkbox} from "@material-ui/core";
import FilterListIcon from '@material-ui/icons/FilterList';

export default function DisplayColumnsButton(props) {
    const { storageKey, displayColumns, setDisplayColumns, isChange } = props;

    const [anchorEl, setAnchorEl] = useState(null);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleColumnVisibility = column => {
        setDisplayColumns(dc => {
            const temp = { ...dc };
            temp[column] = !temp[column];
            return temp;
        });
    };

    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(displayColumns));
    }, [displayColumns]); // eslint-disable-line react-hooks/exhaustive-deps

    return (<div style={isChange ? { display: "flex", justifyContent: "end", marginTop: 20 } : {}}>
        <RaButton className='customCreateBtnStyle'  title="Display Columns" onClick={event => setAnchorEl(event.currentTarget)}><FilterListIcon style={{fontSize: 22}} /></RaButton>
        <Popover
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            {Object.keys(displayColumns)
                .map(column => (
                    <ListItem key={column} dense button onClick={() => toggleColumnVisibility(column)}>
                        <ListItemIcon>
                            <Checkbox
                                edge="start"
                                checked={displayColumns[column]}
                                tabIndex={-1}
                                disableRipple
                            />
                        </ListItemIcon>
                        <ListItemText primary={column} />
                    </ListItem>
                ))}
        </Popover>

    </div>);
}